import { initializeApp, } from 'firebase/app';
import { initializeAnalytics } from 'firebase/analytics';
import { getRemoteConfig, isSupported } from 'firebase/remote-config';
import { configFirebase } from '../environment-variables';

const firebaseConfig = {
  apiKey: configFirebase.apiKey,
  projectId: configFirebase.projectId,
  messagingSenderId: configFirebase.messagingSenderId,
  appId: configFirebase.appId,
  measurementId: configFirebase.measurementId,
  authDomain: configFirebase.authDomain,
};

export const app = initializeApp(firebaseConfig, configFirebase.appName);

initializeAnalytics(app, {
  config: {
    send_page_view: false,
  },
});

export const remoteConfig = async () => (await isSupported()) && getRemoteConfig(app);
